import App from "./App.ce.vue";
import SpGoogleMapsAutoComplete from "#ce/components/SpGoogleMaps/SpGoogleMapsAutoComplete.ce.vue";
import { GOOGLE_MAPS_LOADER, useGoogleMaps } from "#ce/components/SpGoogleMaps/composables/useGoogleMaps";
import { enrichProps } from "#ce/framework/utils";

export function setup(defaults = {}) {
  const { apiKey } = enrichProps(SpGoogleMapsAutoComplete, "SpGoogleMapsAutoComplete.ce.vue", defaults);
  const mapsRegistration = {
    install(app) {
      app.provide(GOOGLE_MAPS_LOADER, (options) => useGoogleMaps({ ...options, apiKey: apiKey.default }));
    },
  };
  return {
    component: App,
    plugins: [mapsRegistration],
  };
}
